import React, { Suspense, useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { getLocalStorage } from "../utils/function/localStorage";
import { routers } from "./_routers";
import "../components/Pending/_pending.scss";
import { useGetLoginUserQuery } from "../services/userApi";

const AppContent = () => {
  const { data } = useGetLoginUserQuery();
  const navigate = useNavigate();
  const token = getLocalStorage("tp_Aa_uth_access");
  useEffect(() => {
    if (!token) {
      navigate("/");
    }
  }, [navigate, token]);

  const perRoute = routers?.filter((rt) =>
    rt?.permission?.includes(data?.data?.role)
  );
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Suspense
        fallback={
          <div className="pending_log">
            <img
              className="skeleton"
              src="https://res.cloudinary.com/djfzcmvmr/image/upload/v1706605752/TaskPlanet/logo_bak4ht.png"
              alt="pending"
            ></img>
            <div className="loading">
              <div className="line-box">
                <div className="line"></div>
              </div>
            </div>
          </div>
        }
      >
        <Routes>
          <>
            {perRoute?.map((route, idx) => {
              return (
                route.component && (
                  <Route
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    element={<route.component />}
                  />
                )
              );
            })}
          </>
        </Routes>
      </Suspense>
    </>
  );
};

export default AppContent;
